import Vue from "vue";
import Vuex from "vuex";

import payload from "@/template/parameter/opts.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: "ja",
    user: null,
    payload: payload, // 送信情報
    inputFile: {} as File, // 入力ファイル
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setPayload(state, payload) {
      state.payload = payload;
    },
    setFile(state, file) {
      state.inputFile = file;
    },
  },
  actions: {},
  modules: {},
});
